import clsx from "clsx";
import { imgAuthSocialClub } from "@/shared/assets/img";
import { RockStarIcon } from "@/shared/icons";

type Props = {
  socialClub: string;
};

export default function AuthSocialClub({ socialClub }: Props) {
  return (
    <div
      className={clsx(
        "p-5 rounded-2xl text-16 font-bold mb-5 flex items-center gap-2.5",
        "bg-dark-800 dark:bg-gradient-to-r from-accent-muted/20 to-40%",
      )}
    >
      <div className="rounded-xl w-10 aspect-square relative p-0.75">
        <div className="rounded-border" />
        <img
          // src={`https://a.rsg.sc/n/${socialClub}`} // TODO: tmp
          src={imgAuthSocialClub}
          alt=""
          className="w-full h-full object-cover rounded-lg"
        />
      </div>
      <div className="flex items-center gap-1">
        <RockStarIcon size={16} className="text-accent-solid" />
        <span className="text-accent font-medium">Social Club:</span> {socialClub}
      </div>
    </div>
  );
}
